import {AVariableContext} from '../../../enums';

export class AVariableReq {
    value!: string;
}
export enum VVariableMutabilityType {
    ReadOnly = 0,
    WriteOnly = 1,
    ReadAndWrite = 2,
}

export enum VVariableType {
    String = 'string',
    Integer = 'int',
    Color = 'color',
    File = 'file',
    ComputedRuntimeInteger = 'computed:runtime:int',
    ComputedRuntimeString = 'computed:runtime:string',
}

export class AVariableRes {
    id!: number;
    name!: string;
    value!: string;
    mutability!: VVariableMutabilityType;
    mutabilityName!: string;
    contextName!: string;
    context!: AVariableContext;
    type!: VVariableType | string;
    computedValue?: unknown;
    resolvedValue?: unknown;
    supportsReferences!: boolean;
    canBeReferenced!: boolean;
}
export class AVariableResolvePreviewReq {
    name!: string;
    value: string = '';
}

export class AVariableResolvePreviewRes {
    value: string = '';
}
